import Loader from "@components/Loader";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { Col, Button, Card, CardBody, ButtonToolbar } from "reactstrap";
import { showNotification } from "@easydev/Notification";
import { useTranslation } from "react-i18next";
import updateWhiteListMapper from "@mappers/GatingSystem/updateWhiteListMapper.mapper";
import updateWhiteList from "@services/GatingSystem/updateWhiteList";
import WhiteListValidate from "@validators/GatingSystem/WhiteList.validate";
import Switch from "@components/Switch";
import BoxIcon from "@components/BoxIcon";
import AlertGatingSystem from "./AlertGatingSystem";
import useGatingSystem from "@hooks/GatingSystem/useGatingSystem";

const TabWhitelist = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation("core");
  const { projectId } = useParams<{
    projectId: string;
  }>();
  const { gatingSystem, updateGatingSystem, loading } =
    useGatingSystem(projectId);

  const handleEditWhitelist = (FormValues: Record<string, any>) => {
    setIsLoading(true);
    const gatingDto = updateWhiteListMapper(FormValues);

    updateWhiteList(projectId, gatingDto)
      .then(async () => {
        if (gatingSystem) {
          gatingSystem.whitelist = gatingDto;
          updateGatingSystem(gatingSystem);
        }
      })
      .catch((error) => {
        showNotification(
          `${t("core:common.gating_system")} | ${t("core:common.whitelist")}`,
          `${t("core:notifications.err_message")} ${
            error?.response?.data?.error
          }`,
          t("core:common.danger")
        );
      })
      .finally(() => {
        setIsLoading(false);
        showNotification(
          `${t("core:common.gating_system")} | ${t("core:common.whitelist")}`,
          t("core:notifications.update_success_message"),
          t("core:common.success")
        );
        window.location.reload();
      });
  };

  if (loading) {
    return <Loader isInsideThing />;
  }

  if (gatingSystem?.password.enabled || gatingSystem?.contract.enabled) {
    return <AlertGatingSystem />;
  }

  return (
    <Col xs={12} md={12} lg={12} xl={8}>
      <Card>
        <CardBody>
          <Form
            onSubmit={(FormValues) => {
              handleEditWhitelist(FormValues);
            }}
            validate={WhiteListValidate}
          >
            {({ handleSubmit, values }) => (
              <form className="form form--horizontal" onSubmit={handleSubmit}>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t("core:common.state")}
                  </span>
                  <div className="form__form-group-field">
                    <Switch
                      name="state"
                      leftText={t("core:common.disabled")}
                      rightText={t("core:common.enabled")}
                      checked={gatingSystem?.whitelist.enabled}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t("core:common.message")}
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="message"
                      component="textarea"
                      maxLength={100}
                      initialValue={gatingSystem?.whitelist.message}
                      disabled={!values?.state}
                      type="text"
                      isAboveError
                    />
                    <BoxIcon
                      id="ButtonWhitelist"
                      title={t("core:notifications.information-icon")}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t("core:common.whitelist")}
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="whitelistedAddresses"
                      component="textarea"
                      type="text"
                      initialValue={gatingSystem?.whitelist.whitelistedAddresses?.join(
                        "\n"
                      )}
                      disabled={!values?.state}
                      isAboveError
                    />
                  </div>
                </div>

                {isLoading ? (
                  <Loader isInsideThing />
                ) : (
                  <ButtonToolbar className="form__button-toolbar">
                    <Button color="success" type="submit">
                      <span className="lnr lnr-pencil"></span>{" "}
                      {t("core:common.save")}
                    </Button>
                  </ButtonToolbar>
                )}
              </form>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabWhitelist;
